module.exports = __webpack_public_path__ + "img/card.f0f2ea26.svg";